import { Component, OnInit, Input, inject, DestroyRef } from '@angular/core';
import { ErrorStateService, RegistrationStepService, StepType, MembershipOption } from '@fgb/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgbcl-registration-select-membership-option',
  templateUrl: './registration-select-membership-option.html',
  styleUrls: ['./registration-select-membership-option.scss'],
})
export class RegistrationSelectCustomerMembershipOptionComponent implements OnInit {
  @Input() Form: FormGroup;
  readonly stepType = StepType.SelectCustomerMembershipOption;
  selectedMembershipOptionId: number;
  isLoaded: boolean = false;

  @Input() membershipOptions: MembershipOption[] = [];
  private destroyRef = inject(DestroyRef);

  constructor(
    private registrationStepService: RegistrationStepService,
    public errorService: ErrorStateService
  ) {}

  ngOnInit() {
    this.registrationStepService
      .fetchRegistrationStepForCurrentWizard(this.stepType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          if (res) {
            this.membershipOptions = res.Data.MembershipOptions || [];
            this.selectedMembershipOptionId = res.Data.Selection.MembershipOptionId;
          }
        },
        complete: () => {
          this.isLoaded = true;
        },
      });
  }

  setSelected(membershipOptionId: number) {
    this.selectedMembershipOptionId = membershipOptionId;
  }

  submitStep() {
    if (this.selectedMembershipOptionId) {
      firstValueFrom(
        this.registrationStepService.submitRegistrationStepData(this.stepType, {
          membershipOptionId: this.selectedMembershipOptionId,
        })
      );
    }
  }
}
